import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { Button, Col, Modal, Row, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SectionLoader from '../../../components/SectionLoader';
import DeleteConfirmation from './DeleteConfirmation';
import axios from 'axios';
import { error, success } from "../../../notify";

const AdminUsers = (props) => {
    let history = useNavigate();
    const ERR_NETWORK_MESSAGE = 'Server is not available.'
    const token = sessionStorage.getItem("revizeTrainingToken");
    const loggedInUserId = sessionStorage.getItem("loggedInUserId");
    const loggedInUserEmail = sessionStorage.getItem("loggedInUserEmail");
    const userRole = sessionStorage.getItem("userRole");
    const [userData, setUserData] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [userId, setUserId] = useState("");
    const [searchInputValue, setSearchInputValue] = useState("");
    const [showClearButton, setShowClearButton] = useState(false);
    
    const adminUsersApi = `${process.env.REACT_APP_SERVER_URL}/api/users/admin`;
    const addUserApi = `${process.env.REACT_APP_SERVER_URL}/api/users`;
    const editUserApi = `${process.env.REACT_APP_SERVER_URL}/api/admin_user/`;
    const deleteUserApi = `${process.env.REACT_APP_SERVER_URL}/api/user/`;
    const emailExistApi = `${process.env.REACT_APP_SERVER_URL}/api/user/email/?email=`;
    const resetPasswordApi = `${process.env.REACT_APP_SERVER_URL}/api/user/resetPassword/?user_id=`;
    const setPageLimitURL = `${process.env.REACT_APP_SERVER_URL}/api/set-page-limit/`;
    const resetQRApi = `${process.env.REACT_APP_SERVER_URL}/api/user/reset_qr`;

    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("")
    const [confirmPasswordError, setConfirmPasswordError] = useState("")
    const [isActive, setActive] = useState(true);
    const [role, setRole] = useState("ADMIN");
    const [emailError, setEmailError] = useState(false);

    const [deleteMessage, setDeleteMessage] = useState(null);

    const [showAddUser, setShowAddUser] = useState(false);
    const [showEditUser, setShowEditUser] = useState(false);
    const [showDeleteUser, setShowDeleteUser] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showResetQRModal, setShowResetQRModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    
    const [currentEditUser, setCurrentEditUser] = useState({
        firstName: '',
        lastName: '',
        email: '',
        isActive: true
    });

    // Search functionality
    const handleSearch = async () => {
        if (searchInputValue.trim() !== "") {
            setShowClearButton(true);
            const filtered = userData.filter(item =>
                item.first_name.toLowerCase().includes(searchInputValue.toLowerCase()) ||
                item.last_name.toLowerCase().includes(searchInputValue.toLowerCase()) ||
                item.email.toLowerCase().includes(searchInputValue.toLowerCase())
            );
            setFilteredUsers(filtered);
        }
    };

    const handleClearSearch = () => {
        setSearchInputValue("");
        setShowClearButton(false);
        setFilteredUsers(userData);
    };

    const handleSearchInputChange = (event) => {
        setSearchInputValue(event.target.value);
        if (event.target.value.trim() === "") {
            setShowClearButton(false);
            setFilteredUsers(userData);
        }
    };

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    // Refresh functionality
    const handleRefresh = async () => {
        try {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            const response = await axios.get(adminUsersApi, { headers: headers });
            setUserData(response.data);
            setFilteredUsers(response.data);
            setSearchInputValue("");
            setShowClearButton(false);
            success("Users refreshed successfully.",true);
        } catch (err) {
            error(err.response?.data?.message || "Failed to refresh users.");
        }
    };

    // Back functionality
    const handleBack = () => {
        history(-1); // Go back to previous page in history
    };

    useEffect(() => {
        console.log("Global Users");
        if (token) {
            fetchData();
        } else {
            setIsLoading(false);
            history('/auth/sign-in');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function fetchData() {
        setIsLoading(true);
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };

        try {
            const response = await axios.get(adminUsersApi, { headers: headers });
            const data = response.data;
            console.log("adminUsersApi data", data)
            setUserData(data);
            setFilteredUsers(data);
        } catch (err) {
            if (err === 'ERR_NETWORK') {
                error(ERR_NETWORK_MESSAGE, true)
            } else {
                error(err.response.data.detail, true)
            }
            history('/dashboard');
        } finally {
            setIsLoading(false);
        }
    }

    // Icons
    const EditIcon = () => (
        <svg width="16" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.7476 20.4428H21.0002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M12.78 3.79479C13.5557 2.86779 14.95 2.73186 15.8962 3.49173C15.9485 3.53296 17.6295 4.83879 17.6295 4.83879C18.669 5.46719 18.992 6.80311 18.3494 7.82259C18.3153 7.87718 8.81195 19.7645 8.81195 19.7645C8.49578 20.1589 8.01583 20.3918 7.50291 20.3973L3.86353 20.443L3.04353 16.9723C2.92866 16.4843 3.04353 15.9718 3.3597 15.5773L12.78 3.79479Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.021 6.00098L16.4732 10.1881" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const DeleteIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const RefreshIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5a6acf" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 2v6h6"></path>
            <path d="M21 12a9 9 0 0 0-15-6.7L3 8"></path>
            <path d="M21 22v-6h-6"></path>
            <path d="M3 12a9 9 0 0 0 15 6.7L21 16"></path>
        </svg>
    );

    const BackIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
            <line x1="5" y1="6" x2="5" y2="18"></line>
        </svg>
    );

    const PasswordIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
    );

    const QRIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="6" height="6"></rect>
            <rect x="15" y="3" width="6" height="6"></rect>
            <rect x="3" y="15" width="6" height="6"></rect>
            <rect x="15" y="15" width="6" height="6"></rect>
            <path d="M9 9h6v6H9z"></path>
        </svg>
    );

    const SearchIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
    );

    const ClearIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    );

    // Status style function with updated colors
    const getStatusStyle = (status) => {
        let borderColor, bgColor, textColor;
        switch (status) {
            case "ACTIVE":
                borderColor = "#438867";
                bgColor = "#e8f5e8";
                textColor = "#438867";
                break;
            case "INACTIVE":
                borderColor = "#dd4e44";
                bgColor = "#fde8e6";
                textColor = "#dd4e44";
                break;
            default:
                borderColor = "#6C757D";
                bgColor = "#F8F9FA";
                textColor = "#6C757D";
        }
        return {
            border: `1px solid ${borderColor}`,
            backgroundColor: bgColor,
            color: textColor,
            borderRadius: '6px',
            padding: '2px 8px',
            fontSize: '12px',
            fontWeight: 500,
            cursor: 'default',
        };
    };

    // Rest of your existing functions remain the same...
    const handleCloseAddUser = () => {
        setFirstName("");
        setFirstNameError("");
        setLastName("");
        setLastNameError("");
        setEmail("");
        setEmailError("");
        setPassword("");
        setPasswordError("");
        setConfirmPassword("");
        setConfirmPasswordError("");
        setActive(true);
        setShowAddUser(false);
        setRole("ADMIN");
    }

    const handleCloseEditUser = () => {
        setFirstNameError("");
        setLastNameError("");
        setEmailError("");
        setPasswordError("");
        setConfirmPasswordError("");
        setShowEditUser(false);
    }

    const handleCloseDeleteUser = () => setShowDeleteUser(false);

    const handleCloseChangePassword = () => {
        setPassword("");
        setConfirmPassword("");
        setPasswordError("");
        setConfirmPasswordError("");
        setShowChangePassword(false);
    }

    const handleFirstName = (event) => {
        setFirstName(event.trim());
    };

    const handleLastName = (event) => {
        setLastName(event.trim());
    };

    const handleEmail = (event) => {
        setEmail(event.trim());
    };

    const handlePassword = (event) => {
        setPassword(event.trim());
    };

    const handleConfirmPassword = (event) => {
        setConfirmPassword(event.trim());
    };

    const handleRole = (event) => {
        setRole(event.trim());
    };

    const handleActive = (event) => {
        setActive(event);
    };

    const validatePassword = (event) => {
        event.preventDefault();
        if (password === "") {
            setPasswordError("Password is mandatory");
        } else if (confirmPassword !== "" && password !== confirmPassword) {
            setPasswordError("");
            setConfirmPasswordError("Password and Confirm password is not matching");
        } else {
            setPasswordError("");
            setConfirmPasswordError("");
        }
    }

    const validateConfirmPassword = (event) => {
        event.preventDefault();
        if (confirmPassword === "") {
            setConfirmPasswordError("Confirm Password is mandatory");
        } else if (password !== confirmPassword) {
            setConfirmPasswordError("Password and Confirm Password is not matching");
        } else {
            setConfirmPasswordError("");
        }
    }

    const validateFirstName = (event) => {
        event.preventDefault();
        const firstNamePattern = /[a-zA-Z]/;
        if (firstName !== "") {
            setFirstNameError("")
            if (firstName.length < 1) {
                setFirstNameError("First Name should have atleast 1 Character");
            } else if (firstName.length > 30) {
                setFirstNameError("First Name should not exceed 30 Characters");
            } else if (!firstNamePattern.test(firstName)) {
                setFirstNameError("First Name is invalid");
            }
        } else {
            setFirstNameError("First Name is mandatory");
        }
    }

    const validateLastName = (event) => {
        event.preventDefault();
        const lastNamePattern = /[a-zA-Z]/;
        if (lastName !== "") {
            setLastNameError("")
            if (lastName.length < 1) {
                setLastNameError("Last Name should have atleast 1 Character");
            } else if (lastName.length > 30) {
                setLastNameError("Last Name should not exceed 30 Characters");
            } else if (!lastNamePattern.test(lastName)) {
                setLastNameError("Last Name is invalid");
            }
        } else {
            setLastNameError("Last Name is mandatory");
        }
    }

    const validateEmail = (event) => {
        event.preventDefault();
        if (email !== "") {
            if (!isValidEmail(email)) {
                setEmailError('Email is invalid');
                return;
            } else {
                setEmailError("");
            }
        } else {
            setEmailError("Email is mandatory");
        }
    }

    const validateEmailExist = (event) => {
        event.preventDefault();
        if (email !== "") {
            if (!isValidEmail(email)) {
                setEmailError('Email is invalid');
                return;
            } else {
                setEmailError("");
            }
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };

            axios.get(emailExistApi + email, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    if (data) {
                        setEmailError("Email is used for existing user. Try another email");
                    } else {
                        setEmailError("");
                    }
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data.detail, true)
                    }
                });
        } else {
            setEmailError("Email is mandatory");
        }
    }

    function isValidEmail(email) {
        const emailRegex = /^[\w.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    const addUser = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            var data = JSON.stringify({
                "first_name": firstName,
                "last_name": lastName,
                "email": email,
                "hashed_password": password,
                "is_active": isActive,
                "role": role
            });

            axios.post(addUserApi, data, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    const newUserData = [...userData, data];
                    setUserData(newUserData);
                    setFilteredUsers(newUserData);
                    success("User added successfully", true);

                    try {
                        axios.post(setPageLimitURL,
                            {
                                page_limit: 100
                            },
                            {
                                headers: headers,
                                params: { user_id: data.id }
                            }
                        );
                    } catch (setLimitErr) {
                        console.error('Error setting page limit:', setLimitErr);
                        error('Error setting page limit', true);
                    }
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data.detail, true)
                    }
                });

            setFirstName("");
            setLastName("");
            setEmail("");
            setPassword("");
            setActive(true);
        }
    };

    const editUser = () => {
        const hasChanges = (
            currentEditUser.firstName !== firstName ||
            currentEditUser.lastName !== lastName ||
            currentEditUser.email !== email ||
            currentEditUser.isActive !== isActive
        );

        if (token && hasChanges) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            const data = JSON.stringify({
                "user_request": {
                    "first_name": firstName,
                    "last_name": lastName,
                    "email": email,
                    "is_active": isActive
                },
                "website_id": -1
            });

            axios.put(editUserApi + userId, data, { headers: headers })
                .then(() => {
                    updateUserData(userId);
                    success("User updated successfully", true);
                })
                .catch((err) => {
                    if (err.message === 'Network Error') {
                        error(ERR_NETWORK_MESSAGE, true);
                    } else {
                        error(err.response?.data?.detail || "An error occurred", true);
                    }
                });

            setFirstName("");
            setLastName("");
            setEmail("");
        } else if (!hasChanges) {
            console.log("No changes detected.");
        }
    };

    const handleShowEditUser = (userId, firstName, lastName, email, isActive) => {
        setUserId(userId);
        setFirstName(firstName);
        setFirstNameError("");
        setLastName(lastName);
        setLastNameError("");
        setEmail(email);
        setEmailError("");
        setActive(isActive); // Set the actual active status of the user
        setShowEditUser(true);
    };

    const handleShowDeleteUser = (userId, firstName, lastName) => {
        setUserId(userId);
        setFirstName(firstName);
        setLastName(lastName);
        setDeleteMessage(
            "Are you sure you want to delete the user: " +
            (firstName.length > 20 ? firstName.substring(0, 20) + "..." : firstName) + " " +
            (lastName.length > 20 ? lastName.substring(0, 20) + "..." : lastName) + "?"
        );
        setShowDeleteUser(true);
    };

    const handleShowChangePassword = (userId) => {
        setUserId(userId);
        setShowChangePassword(true);
    };

    const updateUserData = (userId) => {
        const currentUserIndex = userData.findIndex((user) => user.id === userId);
        const updatedUser = Object.assign({}, userData[currentUserIndex]);
        updatedUser.first_name = firstName;
        updatedUser.last_name = lastName;
        updatedUser.email = email;
        updatedUser.hashed_password = password;
        updatedUser.is_active = isActive;
        updatedUser.role = role;
        const newUserData = userData.slice();
        newUserData[currentUserIndex] = updatedUser;
        setUserData(newUserData);
        setFilteredUsers(newUserData);
    };

    const deleteUser = () => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
        axios.delete(deleteUserApi + userId, { data: { "website_id": -1 } }, { headers: headers })
            .then((response) => {
                success("User deleted successfully", true);
                const newUserData = userData.filter((val) => val.id !== userId);
                setUserData(newUserData);
                setFilteredUsers(newUserData);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true)
                } else {
                    error(err.response.data.detail, true)
                }
            });

        setShowDeleteUser(false);
    };

    const changePassword = () => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
        var data = JSON.stringify({ "newPassword": password, "website_id": -1 });

        axios.put(resetPasswordApi + userId, data, { headers: headers })
            .then((response) => {
                const data = response.data;
                success(data.message || "Password changed successfully", true);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true)
                } else {
                    error(err.response.data.detail, true)
                }
            });

        setPassword("");
        setConfirmPassword("");
        setShowChangePassword(false);
    };

    const handleModalShow = () => {
        setCurrentEditUser({
            firstName: firstName,
            lastName: lastName,
            email: email,
            isActive: isActive
        });
    };

    const handleResetQR = (userId) => {
        setSelectedUserId(userId);
        setShowResetQRModal(true);
    };

    const handleConfirmResetQR = async () => {
        if (!selectedUserId) return;

        try {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };

            const response = await axios.put(
                `${resetQRApi}/${selectedUserId}`,
                null,
                {
                    headers: headers,
                    params: {
                        user_id: selectedUserId,
                        logged_in_user_role: userRole
                    }
                }
            );

            success(response.data.message || "2FA reset successfully.", true);
            fetchData();
        } catch (err) {
            console.error("Error resetting QR code:", err);
            if (err.message === 'Network Error') {
                error(ERR_NETWORK_MESSAGE, true);
            } else {
                error(err.response?.data?.detail || "Failed to reset 2FA.", true);
            }
        } finally {
            setShowResetQRModal(false);
            setSelectedUserId(null);
        }
    };

    const areAllAddUserFieldsFilled = firstName !== "" && lastName !== "" && email !== "" && password !== "" && confirmPassword !== "" && firstNameError === "" && lastNameError === "" && emailError === "" && passwordError === "" && confirmPasswordError === "";
    const areAllEditUserFieldsFilled = firstName !== "" && lastName !== "" && email !== "" && firstNameError === "" && lastNameError === "" && emailError === "";
    const areAllChangePasswordFieldsFilled = password !== "" && confirmPassword !== "" && passwordError === "" && confirmPasswordError === "";

    return (
        <div style={{ fontFamily: '"Inter", sans-serif', background: '#f8f9fd', margin: 0, padding: '20px', minHeight: '100vh' }}>
            <div style={{ overflowX: 'auto', minWidth: '800px' }}>
            <div style={{ background: '#fff', borderRadius: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', padding: '20px',minWidth: '1200px' }}>
                {/* Header Section - Matching AllowedExternalWebsites.js */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap' }}>
                    <h2 style={{ fontSize: '20px', margin: 0, fontWeight: 600 }}>
                        Admin Users
                    </h2>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        {/* Search Box with Button - Updated to match SiteDocs.js */}
                        <div style={{ position: 'relative', width: '350px' }}>
                            <input
                                type="text"
                                placeholder="Search users..."
                                value={searchInputValue}
                                onChange={handleSearchInputChange}
                                onKeyPress={handleSearchKeyPress}
                                style={{
                                    width: '100%',
                                    padding: '8px 68px 8px 12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    fontSize: '14px'
                                }}
                            />
                            <div style={{
                                position: 'absolute',
                                right: '4px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                gap: '4px',
                                alignItems: 'center'
                            }}>
                                {showClearButton && (
                                    <Button
                                        variant="outline-secondary"
                                        onClick={handleClearSearch}
                                        style={{
                                            background: '#5a6acf',
                                            borderRadius: '8px',
                                            width: '28px',
                                            height: '28px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0',
                                            cursor: 'pointer',
                                            color: '#5a6acf',
                                            transition: 'all 0.2s ease-in-out',
                                            border: '1px solid #ddd',
                                            backgroundColor: 'white',
                                            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.15)',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#5a6acf';
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'white';
                                            e.currentTarget.style.color = '#5a6acf';
                                        }}
                                    >
                                        <ClearIcon />
                                    </Button>
                                )}
                                <Button
                                    variant="primary"
                                    onClick={handleSearch}
                                    style={{
                                        background: '#5a6acf',
                                        borderRadius: '8px',
                                        width: '28px',
                                        height: '28px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0',
                                        cursor: 'pointer',
                                        color: '#5a6acf',
                                        transition: 'all 0.2s ease-in-out',
                                        border: '1px solid #ddd',
                                        backgroundColor: 'white',
                                        boxShadow: '0 1px 1px rgba(0, 0, 0, 0.15)',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#5a6acf';
                                        e.currentTarget.style.color = 'white';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'white';
                                        e.currentTarget.style.color = '#5a6acf';
                                    }}
                                >
                                    <SearchIcon />
                                </Button>
                            </div>
                        </div>

                        <Button
                            variant="outline-secondary"
                            onClick={() => setShowAddUser(true)}
                            style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px 14px',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                            }}
                        >
                            + Add User
                        </Button>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Button
                            variant="outline-secondary"
                            onClick={handleRefresh}
                            style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '0',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                            }}
                        >
                            <RefreshIcon />
                        </Button>
                        <Button
                            variant="outline-secondary"
                            onClick={handleBack}
                            style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '0',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                            }}
                        >
                            <BackIcon />
                        </Button>
                    </div>
                </div>

                {/* Table Section */}
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ textAlign: 'left', fontWeight: 600, fontSize: '14px', color: '#555' }}>
                            <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '20%' }}>First Name</th>
                            <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '20%' }}>Last Name</th>
                            <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '25%' }}>Email</th>
                            <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '10%' }}>Active</th>
                            <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '10%' }}>Role</th>
                            <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center', width: '15%' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan={6} style={{ textAlign: 'center', padding: '14px 10px' }}>
                                    <SectionLoader label="Loading admin users..." className="revize-section-loader--table" />
                                </td>
                            </tr>
                        ) : filteredUsers.length === 0 ? (
                            <tr>
                                <td colSpan={6} style={{ textAlign: 'center', padding: '14px 10px', color: '#888' }}>
                                    {userData.length === 0 ? 'No admin users added yet.' : 'No users found matching your search.'}
                                </td>
                            </tr>
                        ) : (
                        filteredUsers.map((user, index) => (
                            <tr key={index}>
                                <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                    {user.first_name}
                                </td>
                                <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                    {user.last_name}
                                </td>
                                <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                    {user.email}
                                </td>
                                <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                    <button style={getStatusStyle(user.is_active ? "ACTIVE" : "INACTIVE")}>
                                        {user.is_active ? "ACTIVE" : "INACTIVE"}
                                    </button>
                                </td>
                                <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                    {user.role}
                                </td>
                                <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', alignItems: 'center', color: '#555' }}>
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                            <span
                                                onClick={() => handleShowEditUser(user.id, user.first_name, user.last_name, user.email, user.is_active)}
                                                style={{ cursor: 'pointer', display: 'inline-flex' }}
                                            >
                                                <EditIcon />
                                            </span>
                                        </OverlayTrigger>

                                        <OverlayTrigger placement="top" overlay={<Tooltip>Change Password</Tooltip>}>
                                            <span
                                                onClick={() => handleShowChangePassword(user.id)}
                                                style={{ cursor: 'pointer', display: 'inline-flex' }}
                                            >
                                                <PasswordIcon />
                                            </span>
                                        </OverlayTrigger>

                                        <OverlayTrigger placement="top" overlay={<Tooltip>Reset 2FA</Tooltip>}>
                                            <span
                                                onClick={() => user.is_2fa_enabled && handleResetQR(user.id)}
                                                style={{ 
                                                    cursor: user.is_2fa_enabled ? 'pointer' : 'not-allowed', 
                                                    display: 'inline-flex',
                                                    opacity: user.is_2fa_enabled ? 1 : 0.4
                                                }}
                                            >
                                                <QRIcon />
                                            </span>
                                        </OverlayTrigger>

                                        {String(user.id) !== loggedInUserId ? (
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                                                <span
                                                    onClick={() => handleShowDeleteUser(user.id, user.first_name, user.last_name)}
                                                    style={{ cursor: 'pointer', display: 'inline-flex' }}
                                                >
                                                    <DeleteIcon />
                                                </span>
                                            </OverlayTrigger>
                                        ) : (
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Cannot delete your own account</Tooltip>}>
                                                <span
                                                    style={{ cursor: 'not-allowed', display: 'inline-flex', opacity: 0.4 }}
                                                >
                                                    <DeleteIcon />
                                                </span>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                        )}
                    </tbody>
                </table>

            </div>

            {/* Add User Modal - Updated with larger size and better layout */}
            <Modal show={showAddUser} onHide={handleCloseAddUser} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {/* First Name and Last Name in one row */}
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control 
                                        style={{ borderColor: firstNameError ? "red" : null }}
                                        type="text"
                                        placeholder="First Name"
                                        onChange={e => handleFirstName(e.target.value)}
                                        onBlur={validateFirstName}
                                        maxLength={100}
                                    />
                                    {firstNameError && <span style={{ color: "red", fontSize: '12px' }}>{firstNameError}</span>}
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control 
                                        style={{ borderColor: lastNameError ? "red" : null }}
                                        type="text"
                                        placeholder="Last Name"
                                        onChange={e => handleLastName(e.target.value)}
                                        onBlur={validateLastName}
                                        maxLength={100}
                                    />
                                    {lastNameError && <span style={{ color: "red", fontSize: '12px' }}>{lastNameError}</span>}
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Email in second row */}
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control 
                                style={{ borderColor: emailError ? "red" : null }}
                                type="email"
                                placeholder="Email"
                                onChange={e => handleEmail(e.target.value)}
                                onBlur={validateEmailExist}
                                maxLength={100}
                            />
                            {emailError && <span style={{ color: "red", fontSize: '12px' }}>{emailError}</span>}
                        </Form.Group>

                        {/* Password and Confirm Password in third row */}
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control 
                                        style={{ borderColor: passwordError ? "red" : null }}
                                        type="password"
                                        placeholder="Password"
                                        onChange={e => handlePassword(e.target.value)}
                                        onBlur={validatePassword}
                                        maxLength={200}
                                    />
                                    {passwordError && <span style={{ color: "red", fontSize: '12px' }}>{passwordError}</span>}
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control 
                                        style={{ borderColor: confirmPasswordError ? "red" : null }}
                                        type="password"
                                        placeholder="Confirm Password"
                                        onChange={e => handleConfirmPassword(e.target.value)}
                                        onBlur={validateConfirmPassword}
                                        maxLength={200}
                                    />
                                    {confirmPasswordError && <span style={{ color: "red", fontSize: '12px' }}>{confirmPasswordError}</span>}
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Active and Role in fourth row */}
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Active</Form.Label>
                                    <div>
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="True"
                                            name="active"
                                            id="active-true"
                                            onChange={e => handleActive(true)}
                                            defaultChecked
                                        />
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="False"
                                            name="active"
                                            id="active-false"
                                            onChange={e => handleActive(false)}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Role</Form.Label>
                                    <Form.Select onChange={e => handleRole(e.target.value)}>
                                        <option value="ADMIN">ADMIN</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={handleCloseAddUser}
                        style={{ border: '1px solid #ddd', minWidth: '100px'  }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            addUser();
                            handleCloseAddUser();
                        }}
                        disabled={!areAllAddUserFieldsFilled}
                        style={{
                            backgroundColor: '#5a6acf',
                            borderColor: '#5a6acf',
                        }}
                    >
                        Add User
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Edit User Modal - Updated layout */}
            <Modal show={showEditUser} onHide={handleCloseEditUser} onShow={handleModalShow} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {/* First Name and Last Name in first row */}
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="First Name"
                                        value={firstName}
                                        onChange={e => handleFirstName(e.target.value)}
                                        onBlur={validateFirstName}
                                        maxLength={30}
                                    />
                                    {firstNameError && <span style={{ color: "red", fontSize: '12px' }}>{firstNameError}</span>}
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Last Name"
                                        value={lastName}
                                        onChange={e => handleLastName(e.target.value)}
                                        onBlur={validateLastName}
                                        maxLength={30}
                                    />
                                    {lastNameError && <span style={{ color: "red", fontSize: '12px' }}>{lastNameError}</span>}
                                </Form.Group>
                            </Col>
                        </Row>
                        
                        {/* Email in second row */}
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={e => handleEmail(e.target.value)}
                                onBlur={validateEmail}
                                maxLength={100}
                            />
                            {emailError && <span style={{ color: "red", fontSize: '12px' }}>{emailError}</span>}
                        </Form.Group>
                        
                        {/* Active in third row */}
                        {loggedInUserEmail !== email && (
                            <Form.Group className="mb-3">
                                <Form.Label>Active</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="True"
                                        name="active"
                                        id="active-true-edit"
                                        onChange={e => handleActive(true)}
                                        checked={isActive}
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="False"
                                        name="active"
                                        id="active-false-edit"
                                        onChange={e => handleActive(false)}
                                        checked={!isActive}
                                    />
                                </div>
                            </Form.Group>
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={handleCloseEditUser}
                        style={{ border: '1px solid #ddd' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            editUser();
                            handleCloseEditUser();
                        }}
                        disabled={!areAllEditUserFieldsFilled}
                        style={{
                            backgroundColor: '#5a6acf',
                            borderColor: '#5a6acf',
                        }}
                    >
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Change Password Modal */}
            <Modal show={showChangePassword} onHide={handleCloseChangePassword}>
                <Modal.Header closeButton>
                    <Modal.Title>Reset Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control 
                                style={{ borderColor: passwordError ? "red" : null }}
                                type="password"
                                placeholder="Password"
                                onChange={e => handlePassword(e.target.value)}
                                onBlur={validatePassword}
                                maxLength={200}
                            />
                            {passwordError && <span style={{ color: "red", fontSize: '12px' }}>{passwordError}</span>}
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Confirm Password</Form.Label>
                            <Form.Control 
                                style={{ borderColor: confirmPasswordError ? "red" : null }}
                                type="password"
                                placeholder="Confirm Password"
                                onChange={e => handleConfirmPassword(e.target.value)}
                                onBlur={validateConfirmPassword}
                                maxLength={200}
                            />
                            {confirmPasswordError && <span style={{ color: "red", fontSize: '12px' }}>{confirmPasswordError}</span>}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={handleCloseChangePassword}
                        style={{ border: '1px solid #ddd' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            changePassword();
                        }}
                        disabled={!areAllChangePasswordFieldsFilled}
                        style={{
                            backgroundColor: '#5a6acf',
                            borderColor: '#5a6acf',
                        }}
                    >
                        Update Password
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Reset QR Modal */}
            <Modal show={showResetQRModal} onHide={() => setShowResetQRModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Reset 2FA</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to reset Two-Factor Authentication (2FA) for this user?</p>  
                    <p>This action will invalidate their current 2FA setup, requiring the user to scan a new QR code upon their next login.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={() => setShowResetQRModal(false)}
                        style={{ border: '1px solid #ddd' }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="primary"
                        onClick={handleConfirmResetQR}
                        style={{
                            backgroundColor: '#5a6acf',
                            borderColor: '#5a6acf',
                        }}
                    >
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>

            <DeleteConfirmation
                showModal={showDeleteUser}
                proceedDelete="true"
                confirmModal={deleteUser}
                hideModal={handleCloseDeleteUser}
                id={userId}
                message={deleteMessage} />
            </div>
        </div>
    )
}

export default AdminUsers